import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';

const NlLoginStatus = /*@__PURE__*/ proxyCustomElement(class NlLoginStatus extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.info = undefined;
    }
    render() {
        let text = '';
        let color = '';
        if (this.info.authMethod === 'extension') {
            text = 'Extension';
            color = 'border-yellow-300 text-yellow-500 bg-yellow-100';
        }
        else if (this.info.authMethod === 'readOnly') {
            text = 'Read only';
            color = 'border-gray-300 text-gray-400 bg-gray-100';
        }
        else if (this.info.authMethod === 'connect') {
            text = 'Connect';
            color = 'border-teal-300 text-teal-600 bg-teal-100';
        }
        else if (this.info.authMethod === 'local') {
            text = 'Temporary';
            color = 'border-red-300 text-red-600 bg-red-100';
        }
        else if (this.info.authMethod === 'otp') {
            text = 'Delegated';
            color = 'border-orange-300 text-orange-600 bg-orange-100';
        }
        else {
            console.log('unknown auth method', this.info);
            throw new Error('Unknown auth method');
        }
        return (h("div", { key: 'f0e9b20820467a4c427fa60bd1879e3ac7cc7f62' }, h("span", { key: '4c96936eac7dbe558e398f9cff963873659f4aec', class: `${color} rounded-xl border w-auto text-[10px] px-1 ` }, text)));
    }
}, [0, "nl-login-status", {
        "info": [16]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["nl-login-status"];
    components.forEach(tagName => { switch (tagName) {
        case "nl-login-status":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, NlLoginStatus);
            }
            break;
    } });
}
defineCustomElement();

export { NlLoginStatus as N, defineCustomElement as d };

//# sourceMappingURL=ns-login-status.js.map